import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  getSummaryData,
  getMethodCallData,
} from '../../../services/apisService';
import Loading from '../../../components/common/loader';
import RecentReq from './recentReq';

type SummaryTypes = {
  successRate: number;
  totalRequest: number;
  invalidRequest: number;
  apiUnits: number;
};

type MethodCallTypes = {
  methodName: string;
  jsonrpcCount: number;
  wsCount: number;
};

function Metrics() {
  const { id } = useParams<{ id: string }>();
  const [summaryData, setSummaryData] = useState({} as SummaryTypes);
  const [methodCallList, setMethodCallList] = useState<MethodCallTypes[] | []>(
    [],
  );
  const [loaderShow, setLoaderShow] = useState<boolean>(true);

  const callApiSummary = async () => {
    if (id) {
      const response: any = await getSummaryData(id);
      setLoaderShow(false);
      if (response && response.success) {
        setSummaryData(response.data);
      }
    }
  };

  const methodCallApiCall = async () => {
    if (id) {
      const response: any = await getMethodCallData(id);
      setLoaderShow(false);
      if (response && response.success) {
        setMethodCallList(response.data);
      }
    }
  };

  useEffect(() => {
    callApiSummary();
    methodCallApiCall();
  }, []);

  return (
    <div>
      <div className="row justify-content-between">
        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 mt-5">
          <h5>Summary</h5>
          <div className="row">
            <div className="col-6 mt-4">
              <div className="card p-3 h-100">
                <p className="fw-bold">Success % (Last 24 Hrs)</p>
                <h5>
                  {summaryData.successRate !== undefined && summaryData.successRate !== null ? summaryData.successRate : '-'}
                </h5>
              </div>
            </div>
            <div className="col-6 mt-4">
              <div className="card p-3 h-100">
                <p className="fw-bold">Total Request (Last 24 Hrs)</p>
                <h5>
                  {summaryData.totalRequest !== undefined && summaryData.totalRequest !== null ? summaryData.totalRequest : '-'}
                </h5>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6 mt-4">
              <div className="card p-3 h-100">
                <p className="fw-bold">Invalid Request (Last 24 Hrs)</p>
                <h5>
                  {summaryData.invalidRequest !== undefined && summaryData.invalidRequest !== null
                    ? summaryData.invalidRequest
                    : '-'}
                </h5>
              </div>
            </div>
            <div className="col-6 mt-4">
              <div className="card p-3 h-100">
                <p className="fw-bold">API Units Consumed (Last 5 Mins)</p>
                <h5>{summaryData.apiUnits !== undefined && summaryData.apiUnits !== null ? summaryData.apiUnits : '-'}</h5>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-5 col-lg-6 col-md-12 col-sm-12 mt-5">
          <h5>Method call breakdown</h5>
          <div className="row">
            <div className="card p-3 table-responsive mt-4 table-card ">
              <table className="table mb-0">
                <thead>
                  <tr className="d-flex">
                    <th className="text-start" style={{ flex: 2 }} scope="col">Method</th>
                    <th className="text-center" style={{ flex: 1 }} scope="col">HTTP</th>
                    <th className="text-center" style={{ flex: 1 }} scope="col">WS</th>
                    <th className="text-center" style={{ flex: 1 }} scope="col">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {methodCallList && methodCallList.length > 0 ? (
                    methodCallList.map((item, index) => (
                      <tr className="d-flex" key={`method-${index.toString()}`}>
                        <td className="text-start" style={{ flex: 2 }}>{item.methodName}</td>
                        <td className="text-center" style={{ flex: 1 }}>{item.jsonrpcCount}</td>
                        <td className="text-center" style={{ flex: 1 }}>{item.wsCount}</td>
                        <td className="text-center" style={{ flex: 1 }}>{item.jsonrpcCount + item.wsCount}</td>
                      </tr>
                    ))
                  ) : (
                    <div className="text-center">
                      <p className="mt-4 fs-6 text-muted">
                            No Data
                      </p>
                    </div>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <RecentReq />
      {loaderShow && <Loading />}
    </div>
  );
}

export default Metrics;